import { useGrowthbookFeatureValue } from '~/hooks/useGrowthbookFeatureValue';
import { GB_FEATURE_KEYS } from '~/services/abTests/features';

import { COMPLIANCE_PROFILES, ComplianceProfile } from './profiles';
import { resolveComplianceLevel } from './resolveComplianceLevel';

/**
 * React-reactive compliance profile. Subscribes to both compliance flags so
 * the component re-renders when GrowthBook finishes loading features.
 */
export const useComplianceProfile = (): ComplianceProfile => {
  const v1 = useGrowthbookFeatureValue(GB_FEATURE_KEYS.POLYLLM_COMPLIANCE_V1);
  const v2 = useGrowthbookFeatureValue(GB_FEATURE_KEYS.POLYLLM_COMPLIANCE_V2);
  const level = resolveComplianceLevel({ v1: Boolean(v1), v2: Boolean(v2) });
  return COMPLIANCE_PROFILES[level];
};
